import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${theme.font.poppins};
`;

export const Title = styled.h1`
  color: ${theme.colors.blue100};
  font-size: ${theme.font.sizes.xlarge};
  font-weight: ${theme.font.xbold};
  max-width: 800px;
  text-align: center;

  hr {
    margin: 20px auto;
    color: ${theme.colors.blue400};
    border: 2px solid ${theme.colors.blue400};
    max-width: 53px;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 70%;
  margin: 0 auto;
`;

export const NewUsersCard = styled.div`
  padding: 10px 20px;
  border-radius: ${theme.border.xradius};
  background: linear-gradient(180deg, #155a77 0%, #27aae1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: 150px;
  margin-bottom: 20px;

  p {
    margin: 0;
    margin-left: 20px;

    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.white};

    span {
      font-weight: ${theme.font.xbold};
    }
  }

  svg {
    position: absolute;
    left: 40px;
    bottom: 0;
  }
`;
